const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';
const sliders = {
	/**
	 * @description Helper function to initialize a slider with customizable settings.
	 * @param {string} selector - The CSS selector for the slider.
	 * @param {Object} customConfig - Custom configuration options for the slider.
	 */
	initializeSlider: (selector, customConfig = {}) => {
		// Base slider config with default values
		const baseConfig = {
			slidesToShow: 4,
			slidesToScroll: 1,
			speed: 1000,
			rows: 0,
			infinite: true,
			autoplay: true,
			arrows: false,
			responsive:
			[
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2
					}
				}
			]
		};

		// Merge the base config with any custom configurations passed in
		const config = {
			...baseConfig,
			...customConfig
		};

		// Initialize the slider with the merged configuration
		$(selector).each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default sliders;
